export class PTWGasTestRecord {
  id?: number;
  PermitId : number;
  date: Date = new Date();
  result: string;
  user: number;
  username?:string;
}
